import { AnalyticsEventLocation } from 'services/analytics/entities';
import { SongType } from 'services/api/entities';
import { Song } from 'services/store/songs/types';
import { getSongDetailsURL } from 'services/helpers/song';
import CopyToClipboardButton from 'components/CopyToClipboardButton';
import { DisplayAddToLibraryIcon } from '../DisplayAddToLibrary/DisplayAddToLibraryIcon';
import DownloadSection from '../DownloadSection';
import StudioButtonIcon from '../StudioButtonIcon';
import { StudioButtonBox } from '../../styled';
import { ReleaseButtonContainer, ReleaseIconButton } from '../ReleaseButton';
import { SongActionButtonsRowContainer } from './styled';

export interface SongActionButtonsRowProps {
  song: Song;
  location: AnalyticsEventLocation;
  removeFromLibrary: () => void;
  addToLibrary: () => void;
}

export const SongActionButtonsRowItems = ({
  song,
  location,
  removeFromLibrary,
  addToLibrary,
}: SongActionButtonsRowProps) => {
  const { id, songType, title, isInLibrary } = song;

  const isCustomizable = songType === SongType.CUSTOMIZABLE;
  const isAIGenerated = songType === SongType.AI_GENERATED;
  const isStudio = songType === SongType.STUDIO;

  return (
    <>
      {(isAIGenerated || isCustomizable) && (
        <StudioButtonBox>
          <StudioButtonIcon
            songId={id}
            title={title}
            isAIGenerated={isAIGenerated}
            location={location}
          />
        </StudioButtonBox>
      )}

      {!isStudio && (
        <>
          <DisplayAddToLibraryIcon
            isInLibrary={isInLibrary}
            removeFromLibrary={removeFromLibrary}
            addToLibrary={addToLibrary}
          />
          <CopyToClipboardButton
            text={getSongDetailsURL(id, title, isAIGenerated)}
          />
        </>
      )}

      {(isAIGenerated || isStudio) && (
        <ReleaseButtonContainer songId={id} location={location}>
          <ReleaseIconButton songId={id} />
        </ReleaseButtonContainer>
      )}
      <DownloadSection
        songId={id}
        songType={songType}
        location={location}
        addToLibrary={addToLibrary}
      />
    </>
  );
};

const SongActionButtonsRow = (props: SongActionButtonsRowProps) => (
  <SongActionButtonsRowContainer>
    <SongActionButtonsRowItems {...props} />
  </SongActionButtonsRowContainer>
);

export default SongActionButtonsRow;
